// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBySide_wrapper__02tdg","img":"SideBySide_img__SrvGW"};